'use client'
import React, {useState, useRef} from 'react';
import Link from 'next/link';
import Container from './Container';
import UserProfile from './UserProfile';
import {AlignJustify} from 'lucide-react';
import MegaMenu from '@/ui/header-navigation/MegaMenu';
import MobileNavigationDrawer from '@/ui/header-navigation/MobileNavigationDrawer';
import {BUSINESS_NAME, businessDetails} from '@/content/business-details/business-content';
import styles from '@/ui/header-navigation/MegaMenu.module.scss';
import {useTheme} from '@mui/material/styles';
import SearchBox from "@/ui/search-box/SearchBox";

const HeaderNavigation = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const {branding: {headerLogoUrl}} = businessDetails;
    const drawerButtonRef = useRef(null);
    const theme = useTheme();
    const gradient = `linear-gradient(${theme.custom.headerBackgroundGradient.direction}, ${theme.custom.headerBackgroundGradient.start}, ${theme.custom.headerBackgroundGradient.end})`;

    return (
        <div
            // className={`${styles.navHeader} sticky top-0 z-50`}
            className='sticky top-0 z-50 bg-white shadow-md'
            style={{
                backgroundImage: gradient, // Apply gradient
                color: theme.palette.text.primary,
            }}
        >
            <Container>
                <div className={styles.toolbar}>
                    <button
                        ref={drawerButtonRef}
                        className={`${styles.menuIcon} ${styles.mdHidden}`}
                        aria-haspopup="true"
                        onClick={() => setIsDrawerOpen(true)}
                    >
                        {/* Mobile Hamburger menu */}
                        <AlignJustify/>
                    </button>
                    <Link className={styles.logoLink} href={'/'}>
                        <img src={headerLogoUrl} alt={BUSINESS_NAME}/>
                    </Link>

                    <div className={`${styles.hidden} ${styles.mdBlock}`}>
                        <MegaMenu/>
                    </div>
                    <UserProfile/>

                    {/* Mobile navigation drawer */}
                    <div className={`${styles.mdHidden} ${styles.absolute}`}>
                        <MobileNavigationDrawer
                            {...{isDrawerOpen, setIsDrawerOpen, drawerButtonRef}}
                        />
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default HeaderNavigation;
